type Diagnostic = {
  at: string;
  event: string;
  durationMs?: number;
  status?: string;
  provider?: string;
  queueMs?: number;
  processingMs?: number;
};
const key = 'enactry.diagnostics.v1';
/** Bounded device-local technical metadata. Never accept text, audio or equations. */
export function diagnostic(
  event:
    | 'stt'
    | 'tutor'
    | 'tts'
    | 'speech-start'
    | 'play'
    | 'replay'
    | 'pause'
    | 'note-open'
    | 'note-delete',
  durationMs?: number,
  status?: 'ok' | 'aborted' | 'error' | 'empty' | 'cached',
  metadata?: {provider?: string; timingMs?: {queue:number;processing:number}},
) {
  try {
    const entries = readDiagnostics();
    entries.push({
      at: new Date().toISOString(),
      event,
      ...(durationMs !== undefined
        ? { durationMs: Math.round(durationMs) }
        : {}),
      ...(status ? { status } : {}),
      ...(metadata?.provider && /^[a-z0-9_.\/-]{1,80}$/i.test(metadata.provider) ? {provider:metadata.provider} : {}),
      ...(Number.isFinite(metadata?.timingMs?.queue) ? {queueMs:Math.max(0,Math.round(metadata!.timingMs!.queue))} : {}),
      ...(Number.isFinite(metadata?.timingMs?.processing) ? {processingMs:Math.max(0,Math.round(metadata!.timingMs!.processing))} : {}),
    });
    localStorage.setItem(key, JSON.stringify(entries.slice(-200)));
  } catch {}
}
export function readDiagnostics(): Diagnostic[] {
  try {
    const rows = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(rows)
      ? rows
          .filter(
            (r) => r && typeof r.at === 'string' && typeof r.event === 'string',
          )
          .slice(-200)
          .map((r) => ({
            at: r.at.slice(0, 40),
            event: ['stt','tutor','tts','speech-start','play','replay','pause','note-open','note-delete'].includes(r.event) ? r.event : 'unknown',
            ...(Number.isFinite(r.durationMs) ? { durationMs: Math.max(0, r.durationMs) } : {}),
            ...(['ok','aborted','error','empty','cached'].includes(r.status) ? {status:r.status} : {}),
            ...(typeof r.provider === 'string' && /^[a-z0-9_.\/-]{1,80}$/i.test(r.provider) ? {provider:r.provider} : {}),
            ...(Number.isFinite(r.queueMs) ? {queueMs:Math.max(0,r.queueMs)} : {}),
            ...(Number.isFinite(r.processingMs) ? {processingMs:Math.max(0,r.processingMs)} : {}),
          }))
      : [];
  } catch {
    return [];
  }
}
export function downloadDiagnostics() {
  const url = URL.createObjectURL(
    new Blob(
      [
        JSON.stringify(
          {
            version: 1,
            scope:
              'Device-local technical timings; no microphone audio or conversation text',
            events: readDiagnostics(),
          },
          null,
          2,
        ),
      ],
      { type: 'application/json' },
    ),
  );
  const a = document.createElement('a');
  a.href = url;
  a.download = 'enactry-troubleshooting.json';
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
